<div class="wrapper">
  <mat-icon role="img" color="secondary"
            class="mat-icon notranslate mat-secondary material-icons mat-ligature-font mat-icon-no-color icon ">info
  </mat-icon>
  <div class="text-wrapper">
    <p class="text">
      Щось пішло не так і контактні дані не підтягнулися.
    </p>
    <p class="text">
      Щоб виправити це, зверніться до підтримки <a class="link-grey link-grey-text" href="mailto:support@novaposhta.ua"
                                                   target="_blank">support@novaposhta.ua</a>
      або скористайтесь чатом з оператором
    </p>
  </div>
</div>
